import React, { FC } from 'react';
import { FormikProps } from 'formik';
import { SignUpFormData, TRole } from '../../../../../models/auth/@types';

import Popover, { PopoverComp } from '../../../../Popover';
import Icons from '../../../../SvgLib/icons';
import { TAuthMessages } from '../../../@types';
import TextField from '../../../../FormFields/TextField';
import Typo from '../../../../Typo';
import { getFieldError } from '../../../../FormFields/Utils';
import parentStyles from '../../signUpForm.module.sass';
import styles from './email.module.sass';

export interface EmailProps {
  valueKey: string;
  formikProps: FormikProps<Partial<SignUpFormData>>;
  messages: TAuthMessages;
}

const Email: FC<EmailProps> = props => {
  const { valueKey, formikProps, messages } = props;
  const error = getFieldError(valueKey, formikProps);
  const setupLoginPopover = messages['Signup - Setup Login'];
  return (
    <div className={styles.emailRoot}>
      <Typo normal classes={`is-block mb-1 ${styles.fieldLabel}`}>
        Create a login
        {setupLoginPopover && (
          <Popover
            popoverComp={PopoverComp({
              title: setupLoginPopover.heading,
              subtitle: setupLoginPopover.description,
            })}
            childProps={{ className: parentStyles.popover }}
          >
            {Icons({}).questionMark}
          </Popover>
        )}
      </Typo>

      <TextField
        valueKey={valueKey}
        error={error}
        rootClassName={styles.emailField}
        placeHolderColorBlack
        otherFieldProps={{
          placeholder: `${
            formikProps?.values?.role === TRole.MENTOR ? 'Company Email Address' : 'Email Address'
          }`,
          onChange: formikProps.handleChange,
          onBlur: formikProps.handleBlur,
          value: formikProps?.values?.email,
        }}
        type="email"
      />
    </div>
  );
};

export default Email;
